import React, { useMemo } from "react";
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
import { useSelector } from "react-redux";

const ProgressSteps = ({ currentStep = 1 }) => {
  const masterdata = useSelector((state) => state.globalslice.masterdata || []);

  // Prepare tabs data from masterdata
  const tabs_data = useMemo(() => (
    (masterdata || [])
      .filter(ele => ele.list_type === 'order_status')
      .map((item) => ({
        id: String(item.list_value), // Ensure id is string for consistent comparison
        title: item.list_lable,
        list_key: item.list_key,
      }))
  ), [masterdata]);

  // Filtered tab data based on business rules
  const filteredTabData = useMemo(() => {
    if (!tabs_data || tabs_data.length === 0) return [];

    const stepNum = Number(currentStep);

    if (stepNum < 7) {
      // Show tabs with id < 7
      return tabs_data.filter(tab => Number(tab.id) < 7);
    }

    if (stepNum === 7) {
      // Show Ordered (1), Delivered (6), Cancelled (7)
      return tabs_data.filter(tab =>
        ["1", "7"].includes(tab.id)
      );
    }

    if (stepNum === 8) {
      // Show Ordered (1), Delivered (6), Return (8)
      return tabs_data.filter(tab =>
        ["1", "6", "8"].includes(tab.id)
      );
    }

    if (stepNum === 11) {
      // Show Ordered (1), Cancelled b/f Dispatch (11)
      return tabs_data.filter(tab =>
        ["1", "11"].includes(tab.id)
      );
    }

    // Default: return all
    return tabs_data;
  }, [tabs_data, currentStep]);

  // Prepare step labels
  const steps = useMemo(() => (
    filteredTabData.length > 0
      ? filteredTabData.map(item => item.title)
      : ['Ordered', 'Processed', 'Packed', 'Out For Delivery', 'Delivered']
  ), [filteredTabData]);

  const totalSteps = steps.length;
  const stepWidth = totalSteps > 1 ? 100 / (totalSteps - 1) : 100;

  // Calculate activeStep index based on currentStep id in filteredTabData
  const activeStepIndex = filteredTabData.findIndex(item => item.id === String(currentStep));
  const activeStep = activeStepIndex !== -1 ? activeStepIndex + 1 : 1;

  return (
    <ErrorBoundary fallback={<div>Oops! Something went wrong.</div>}>
      <div className="position-relative" style={{ height: "4rem" }}>
        {/* Progress bar */}
        <div className="progress" style={{ height: '1px' }}>
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${(activeStep - 1) * stepWidth}%` }}
            aria-valuenow={activeStep}
            aria-valuemin="0"
            aria-valuemax={totalSteps}
          ></div>
        </div>

        {/* Step buttons with labels */}
        {steps.map((label, index) => {
          const step = index + 1;
          const isCompleted = step < activeStep;
          const isActive = step === activeStep;

          let buttonClass = "btn btn-sm rounded-pill ";
          buttonClass += (isCompleted || isActive) ? "btn-primary" : "btn-light";

          return (
            <div
              key={step}
              className="position-absolute translate-middle text-center"
              style={{
                top: "10px",
                left: `${(index / (totalSteps - 1)) * 100}%`,
                transform: "translate(-50%, -50%)",
              }}
            >
              <button
                type="button"
                className={buttonClass}
                style={{ width: "2rem", height: "2rem" }}
                aria-label={`Step ${step}: ${label}`}
              >
                {step}
              </button>
              <div className="orderstatusbar-text"
           
              >
                {label}
              </div>



            </div>
          );
        })}
      </div>
    </ErrorBoundary>
  );
};

export default React.memo(ProgressSteps);
